import { Navigate, Route, Routes } from 'react-router-dom'
import { RequireAdmin } from './lib/auth'
import { AdminAppShell } from './components/AdminAppShell'
import { AdminLoginPage } from './pages/AdminLoginPage'
import { AdminOverviewPage } from './pages/AdminOverviewPage'
import { UserListPage } from './pages/UserListPage'
import { UserDetailPage } from './pages/UserDetailPage'
import { ReviewQueuePage } from './pages/ReviewQueuePage'
import { ReviewDetailPage } from './pages/ReviewDetailPage'
import { FraudPanelPage } from './pages/FraudPanelPage'
import { PayoutQueuePage } from './pages/PayoutQueuePage'
import { AuditLogPage } from './pages/AuditLogPage'
import { AdminSettingsPage } from './pages/AdminSettingsPage'
import { NotFoundPage } from './pages/NotFoundPage'

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <RequireAdmin>
      <AdminAppShell>{children}</AdminAppShell>
    </RequireAdmin>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLoginPage />} />

      <Route path="/" element={<Shell><Navigate to="/overview" replace /></Shell>} />
      <Route path="/overview" element={<Shell><AdminOverviewPage /></Shell>} />
      <Route path="/users" element={<Shell><UserListPage /></Shell>} />
      <Route path="/users/:id" element={<Shell><UserDetailPage /></Shell>} />
      <Route path="/reviews" element={<Shell><ReviewQueuePage /></Shell>} />
      <Route path="/reviews/:id" element={<Shell><ReviewDetailPage /></Shell>} />
      <Route path="/fraud" element={<Shell><FraudPanelPage /></Shell>} />
      <Route path="/payouts" element={<Shell><PayoutQueuePage /></Shell>} />
      <Route path="/audit" element={<Shell><AuditLogPage /></Shell>} />
      <Route path="/settings" element={<Shell><AdminSettingsPage /></Shell>} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
